import { localToRemoteUrl } from '../helpers/urls';
import {
  cleanPhone,
  formatDisplayNameWithPrefix,
  formatName,
} from '../helpers/format';
import { isContactPrefixEnabled } from '../helpers/featureFlags';
import Company from './company';
import { formatRelativeTime } from '@app/i18n/formatters/date';

class User {
  constructor(user) {
    this.id = user.id || user._id;
    const profile = user.profile || { firstName: '', lastName: '' };
    this.imageUrl = localToRemoteUrl(profile.imageUrl || user.imageUrl);
    this.firstName = user.firstName || profile.firstName;
    this.lastName = user.lastName || profile.lastName;
    this.contactPrefix = user.contactPrefix || profile.contactPrefix;
    const prefixEnabled = isContactPrefixEnabled();
    const activePrefix =
      prefixEnabled && this.contactPrefix ? this.contactPrefix : '';
    this.nameTableFormat = formatName({
      firstName: this.firstName,
      lastName: this.lastName,
      contactPrefix: activePrefix,
    });
    this.name = formatDisplayNameWithPrefix({
      contactPrefix: activePrefix,
      firstName: this.firstName,
      lastName: this.lastName,
    });
    this.lastActivity =
      user.lastActivity && formatRelativeTime(new Date(user.lastActivity));
    this.lastLoginTime =
      user.lastLoginTime && formatRelativeTime(new Date(user.lastLoginTime));
    this.lastLoginRaw = user.lastLoginTime;

    this.archived = user.active !== undefined ? !user.active : false;

    this.activated = user.verified && !user.blocked && !user.locked;
    this.verified = user.verified;
    this.blocked = user.blocked;
    this.locked = user.locked;
    this.inChatBotMode = user.inChatBotMode;
    this.isAutoAssign = user.isAutoAssign || false;
    this.optIn = user.optIn;

    this.email = user.email;
    this.phone = user.profile?.phoneNumber ?? user.phoneNumber;
    this.phoneNumber = cleanPhone(this.phone);
    this.zipCode = user.zipCode ?? profile.zipCode;
    this.timeZone = user.timeZone ?? profile.timeZone;
    this.contactNumber = user.profile?.contactNumber ?? user.contactNumber;
    this.title = user.profile?.title;
    this.displayPhoneNumber = this.phoneNumber;
    this.ownerOrganization =
      user.ownerOrganization && new Company(user.ownerOrganization);
    this.company = user.ownerOrganization?.name;
    this.role = user.role;
    this.roles = user.roles;
    this.branding = user.branding;
    this.groups = user.groups;
    this.groupLeads = user.groupLeads;
    this.inTranslationMode = user.inTranslationMode;
    this.languagePreference = user.languagePreference;
    this.relationships = user.relationships || [];

    let uniqueId = user.oktaUserId;
    if (user.ownerOrganization?.prefix) {
      const regex = new RegExp(`^(${user.ownerOrganization?.prefix}-)`);
      uniqueId = uniqueId.replace(regex, '');
    }
    this.oktaUserId = uniqueId;
  }
}

export default User;
